import React from "react";
import DataTable from "../../common/ui/data-table/DataTable";
import TableContainer from "../../common/ui/table-container/TableContainer";

const noopSort = () => {};

const DEFAULT_STATE_CELL_STYLE = { padding: "1.5rem", textAlign: "center", color: "#6b7280" };

const UsersDataGrid = ({
  columns,
  rows,
  getRowKey,
  renderRow,
  onRowClick,
  emptyMessage,
  loading = false,
  loadingMessage,
  sortKey = "",
  sortDir = "asc",
  onSort = noopSort,
  getRowClassName,
  stateCellStyle = DEFAULT_STATE_CELL_STYLE,
}) => (
  <div className="users-grid-table-wrap">
    <TableContainer>
      <DataTable
        className="users-grid-table"
        columns={columns}
        rows={rows}
        getRowKey={getRowKey}
        renderRow={renderRow}
        onRowClick={onRowClick}
        getRowClassName={getRowClassName}
        sortKey={sortKey}
        sortDir={sortDir}
        onSort={onSort}
        loading={loading}
        loadingMessage={loadingMessage}
        emptyMessage={emptyMessage}
        stateCellStyle={stateCellStyle}
      />
    </TableContainer>
  </div>
);

export default UsersDataGrid;

export const usersActionsHeaderClass = "users-grid-th-actions";
export const usersActionsCellClass = "users-grid-td-actions";
